window.addEventListener('load', () => {
    const defaultImageUrl = document.querySelector('.placeholder-image').dataset.src;
    function debounce(func, delay) {
        let timeoutId;
        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    }

    const formatPrice = (price) => {
        const number = parseFloat(price);
        const currency = window.theme.settings.money_with_currency_format.replace(/{{.*?}}/g, '');
        
        let locale;
        switch (currency) {
            case '€': 
                locale = 'de-DE';
                break;
            case 'CHF':
                locale = 'de-CH';
                break;
            case 'R$':
                locale = 'pt-BR';
                break;
            case '¥':
                locale = 'ja-JP';
                break;
            case '$':
            default:
                locale = 'en-US';
                break;
        }
    
        return number.toLocaleString(locale, { 
            minimumFractionDigits: 0, 
            maximumFractionDigits: 2 
        });
    };
    
    document.querySelectorAll('.searchform').forEach(searchForm => {
        let lastSearchTerm = '';
        let searchSuggestion;
        let currentSearchTerm = '';
        const searchInput = searchForm.querySelector('fieldset input.search-field');
        const autocompleteTarget = searchForm.querySelector('#ss__autocomplete--target');
        searchInput.addEventListener('input', () => {
            const inputSearch = searchInput.value.trim();
            if(inputSearch.length === 0){
                autocompleteTarget.innerHTML = '';
            }
        });
    
        if (searchInput && autocompleteTarget) {
            document.addEventListener('click', function(event) {
                if (!searchInput.contains(event.target) && !autocompleteTarget.contains(event.target)) {
                    autocompleteTarget.style.display = 'none';
                }
            });
    
            const handleInput = debounce(async (e) => {
                const newSearchTerm = searchInput.value.trim();
                autocompleteTarget.style.display = 'block';
                if (newSearchTerm !== lastSearchTerm) {
                    autocompleteTarget.innerHTML = '';
                    lastSearchTerm = newSearchTerm;
                    if (newSearchTerm.length >= 3) {
                        await loadSearchSuggest(searchForm, newSearchTerm);
                    } else if (newSearchTerm.length === 0) {
                        searchSuggestion = false;
                        autocompleteTarget.innerHTML = '';
                    }
                }
            }, 500);
    
            searchInput.addEventListener('input', handleInput);
    
            // Function to update facets and results based on the search term
            async function updateFacetsAndResults(searchForm, searchTerm, suggestionTerm = false) {
                currentSearchTerm = searchTerm;
                try {
                    const response = await fetch(`/search/suggest.json?q=Combined+instock+${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide&resources[options][fields]=product_type,tag,title`);
                    const data = await response.json();
                    const facetsWrapper = searchForm.querySelector('.ss__autocomplete__facets');
                    const resultssubWrapper = searchForm.querySelector('.ss__autocomplete__results');
    
                    if (!data.resources.results.products || data.resources.results.products.length === 0) {
                        resultssubWrapper.textContent = `No results found for "${searchTerm}".`;
                        facetsWrapper.style.display = 'none';
                        const facetTermSuggest = searchForm.querySelector('.ss__autocomplete__terms');
                        facetTermSuggest.style.display = 'none';
                        throw new Error('No results found');
                    }
    
                    // Clear facets and results but keep suggestions
                    facetsWrapper.innerHTML = '';
                    resultssubWrapper.innerHTML = '';
    
                    // Create facets based on product tags and types
                    const products = data.resources.results.products;
                    const tags = new Set();
                    const types = new Set();
                    const vendors = new Set();
                    
                    products.forEach(product => {
                        if (product.tags) {
                            product.tags.forEach(tag => tags.add(tag));
                        }
                        if (product.product_type) {
                            types.add(product.product_type);
                        }
                        if (product.vendor) {
                            vendors.add(product.vendor);
                        }
                    });
    
                    // Create facet sections
                    const facetData = [
                        { label: 'Tags', values: Array.from(tags).slice(0, 6) },
                        { label: 'Type', values: Array.from(types).slice(0, 6) },
                        { label: 'Vendor', values: Array.from(vendors).slice(0, 6) }
                    ];
    
                    facetData.forEach(facet => {
                        if (facet.values.length > 0) {
                            const facetWrapper = document.createElement('div');
                            facetWrapper.className = `ss__facet ss__facet--list ss__facet--${facet.label.toLowerCase()}`;
        
                            const dropdownWrapper = document.createElement('div');
                            dropdownWrapper.className = 'ss__dropdown';
        
                            const button = document.createElement('button');
                            button.className = 'ss__dropdown__button';
                            button.setAttribute('role', 'button');
        
                            const header = document.createElement('div');
                            header.className = 'ss__facet__header';
                            header.setAttribute('role', 'heading');
                            header.setAttribute('aria-level', '3');
                            header.textContent = facet.label;
                            button.appendChild(header);
        
                            const dropdownContent = document.createElement('div');
                            dropdownContent.className = 'ss__dropdown__content';
        
                            const facetList = document.createElement('ul');
                            facetList.className = 'ss__facet-list-options';
        
                            facet.values.forEach(value => {
                                const listItem = document.createElement('li');
                                const link = document.createElement('a');
                                link.href = `/search?q=${encodeURIComponent(searchTerm)}&filter.v.option.${facet.label.toLowerCase()}=${encodeURIComponent(value)}`;
                                link.textContent = value;
                                link.setAttribute('aria-label', `Filter by ${facet.label} - ${value}`);
                                link.dataset.facetField = facet.label.toLowerCase();
                                link.dataset.facetValue = value;
                                listItem.appendChild(link);
                                facetList.appendChild(listItem);
                            });
        
                            dropdownContent.appendChild(facetList);
                            dropdownWrapper.appendChild(button);
                            dropdownWrapper.appendChild(dropdownContent);
                            facetWrapper.appendChild(dropdownWrapper);
                            facetsWrapper.appendChild(facetWrapper);
                        }
                    });
    
                    // Handle search results
                    products.forEach(product => {
                        const article = document.createElement('article');
                        article.className = 'ss__result ss__result--grid';
    
                        const imageWrapper = document.createElement('div');
                        imageWrapper.className = 'ss__result__image-wrapper';
    
                        const imageLink = document.createElement('a');
                        imageLink.href = `/products/${product.handle}`;
    
                        const image = document.createElement('img');
                        image.src = product?.featured_image?.url || product?.image || defaultImageUrl;
                        image.alt = product?.featured_image?.alt || product.title;
                        image.loading = 'lazy';
    
                        imageLink.appendChild(image);
                        imageWrapper.appendChild(imageLink);
    
                        const detailsWrapper = document.createElement('div');
                        detailsWrapper.className = 'ss__result__details';
    
                        const title = document.createElement('div');
                        title.className = 'ss__result__details__title';
    
                        const titleLink = document.createElement('a');
                        titleLink.href = `/products/${product.handle}`;
                        titleLink.textContent = product.title;
    
                        title.appendChild(titleLink);
    
                        const price = document.createElement('div');
                        price.className = 'ss__result__details__pricing';
    
                        const priceValue = document.createElement('span');
                        priceValue.className = 'ss__price';
                        priceValue.textContent = formatProductPrice(product);
    
                        price.appendChild(priceValue);
                        detailsWrapper.appendChild(title);
                        detailsWrapper.appendChild(price);
    
                        article.appendChild(imageWrapper);
                        article.appendChild(detailsWrapper);
                        resultssubWrapper.appendChild(article);
                    });
                } catch (err) {
                    console.error('updateFacetsAndResults error: ', err);
                    if(suggestionTerm){
                        await updateFacetsAndResults(searchForm, suggestionTerm);
                    }            
                }
            }
    
            // Function to update content results based on filter (hovering facets)
            async function updateContentResultsWithFilter(searchForm, facetField, facetValue) {
                try {
                    const response = await fetch(`/search/suggest.json?q=Combined+instock+${encodeURIComponent(currentSearchTerm)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide&resources[options][fields]=product_type,tag,title${facetField ? `,${facetField}:${facetValue}` : ''}`);
                    const data = await response.json();
                    const resultssubWrapper = searchForm.querySelector('.ss__autocomplete__results');
                    resultssubWrapper.innerHTML = '';
                    if (data.resources.results.products) {
                        data.resources.results.products.forEach(product => {
                            const article = document.createElement('article');
                            article.className = 'ss__result ss__result--grid';
        
                            const imageWrapper = document.createElement('div');
                            imageWrapper.className = 'ss__result__image-wrapper';
        
                            const imageLink = document.createElement('a');
                            imageLink.href = `/products/${product.handle}`;
        
                            const image = document.createElement('img');
                            image.src = product.featured_image ? product.featured_image : defaultImageUrl;
                            image.alt = product.title;
                            image.loading = 'lazy';
        
                            imageLink.appendChild(image);
                            imageWrapper.appendChild(imageLink);
        
                            const detailsWrapper = document.createElement('div');
                            detailsWrapper.className = 'ss__result__details';
        
                            const title = document.createElement('div');
                            title.className = 'ss__result__details__title';
        
                            const titleLink = document.createElement('a');
                            titleLink.href = `/products/${product.handle}`;
                            titleLink.textContent = product.title;
        
                            title.appendChild(titleLink);
        
                            const price = document.createElement('div');
                            price.className = 'ss__result__details__pricing';
        
                            const priceValue = document.createElement('span');
                            priceValue.className = 'ss__price';
                            priceValue.textContent = formatProductPrice(product);
        
                            price.appendChild(priceValue);
                            detailsWrapper.appendChild(title);
                            detailsWrapper.appendChild(price);
        
                            article.appendChild(imageWrapper);
                            article.appendChild(detailsWrapper);
                            resultssubWrapper.appendChild(article);
                        });
                    }
                } catch (err) {
                    console.error('updateContentResultsWithFilter error: ', err);
                }
            }
    
            async function loadSearchSuggest(searchForm, searchTerm) {
                try {
                    const response = await fetch(`/search/suggest.json?q=Combined+instock+${searchTerm}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide&resources[options][fields]=product_type,tag,title`);
                    const suggestData = await response.json();
    
                    const container = searchForm.querySelector('#ss__autocomplete--target');
    
                    // Create the autocomplete wrapper if not already present
                    let autocompleteWrapper = container.querySelector('.ss__autocomplete.ss-pwahfn');
                    if (autocompleteWrapper) {
                        autocompleteWrapper.innerHTML = '';
                    } else {
                        autocompleteWrapper = document.createElement('div');
                        autocompleteWrapper.className = 'ss__autocomplete ss-pwahfn';
                        container.appendChild(autocompleteWrapper);
                    }
    
                    // Create the terms wrapper (for suggestions)
                    const termsWrapper = document.createElement('div');
                    termsWrapper.className = 'ss__autocomplete__terms';
    
                    const termssuggest = document.createElement('div');
                    termssuggest.className = 'ss__autocomplete__terms__suggestions';
    
                    const termsoptions = document.createElement('div');
                    termsoptions.className = 'ss__autocomplete__terms__options';
    
                    termsWrapper.appendChild(termssuggest);
                    termssuggest.appendChild(termsoptions);
                    // Handle the exact match suggestion
                    if (suggestData.resources.results.products && suggestData.resources.results.products.length > 0) {
                        const exactSuggestion = searchTerm;
                        searchSuggestion = exactSuggestion;
                        
                        const exactDiv = document.createElement('div');
                        exactDiv.className = 'ss__autocomplete__terms__option ss__autocomplete__terms__option--active';
    
                        const exactLink = document.createElement('a');
                        exactLink.href = `/search?q=${encodeURIComponent(exactSuggestion)}`;
                        exactLink.setAttribute('role', 'link');
                        exactLink.setAttribute('aria-label', `item 1 of 5, ${exactSuggestion}`);
                        exactLink.textContent = exactSuggestion;
    
                        exactDiv.appendChild(exactLink);
                        termsoptions.appendChild(exactDiv);
    
                        // Add hover functionality
                        const handleExactMouseEnter = debounce(async () => {
                            searchForm.querySelectorAll('.ss__autocomplete__terms__option').forEach(el => el.classList.remove('ss__autocomplete__terms__option--active'));
                            exactDiv.classList.add('ss__autocomplete__terms__option--active');
                            await updateFacetsAndResults(searchForm, exactSuggestion);
                        }, 500);
                        exactDiv.addEventListener('mouseenter', handleExactMouseEnter);
                    }
    
                    // Handle alternative suggestions based on product titles
                    if (suggestData.resources.results.products) {
                        const alternatives = suggestData.resources.results.products.slice(0, 4).map(product => ({
                            text: product.title,
                            handle: product.handle
                        }));
                        
                        alternatives.forEach((alternative, index) => {
                            const alternativeDiv = document.createElement('div');
                            alternativeDiv.className = 'ss__autocomplete__terms__option';
    
                            const alternativeLink = document.createElement('a');
                            alternativeLink.href = `/search?q=${encodeURIComponent(alternative.text)}`;
                            alternativeLink.setAttribute('role', 'link');
                            alternativeLink.setAttribute('aria-label', `item ${index + 2} of 5, ${alternative.text}`);
                            alternativeLink.textContent = alternative.text;
    
                            alternativeDiv.appendChild(alternativeLink);
                            termsoptions.appendChild(alternativeDiv);
    
                            // Add hover functionality
                            const handleAlternativeMouseEnter = debounce(() => {
                                document.querySelectorAll('.ss__autocomplete__terms__option').forEach(el => el.classList.remove('ss__autocomplete__terms__option--active'));
                                alternativeDiv.classList.add('ss__autocomplete__terms__option--active');
                                updateFacetsAndResults(searchForm, alternative.text);
                            }, 500);
                            alternativeDiv.addEventListener('mouseenter', handleAlternativeMouseEnter);
                        });
                    }
    
                    // Append terms to the autocomplete wrapper
                    autocompleteWrapper.prepend(termsWrapper);
    
                    // Create initial facets and results wrapper
                    const facetsWrapper = document.createElement('div');
                    facetsWrapper.className = 'ss__autocomplete__facets';
                    const resultContentWrapper = document.createElement('div');
                    resultContentWrapper.className = 'ss__autocomplete__content';
                    const resultsWrapper = document.createElement('div');
                    resultsWrapper.className = 'ss__autocomplete__content__results';
                    const resultssubWrapper = document.createElement('div');
                    resultssubWrapper.className = 'ss__results ss__results-grid ss__autocomplete__results ss-q1e55l';
                    resultsWrapper.appendChild(resultssubWrapper);
    
                    resultContentWrapper.appendChild(resultsWrapper);
                    autocompleteWrapper.appendChild(facetsWrapper);
                    autocompleteWrapper.appendChild(resultContentWrapper);
    
                    // Add hover functionality to facet options
                    const handleMouseOver = debounce(async (event) => {
                        const facetLink = event.target.closest('.ss__facet-list-options a');
                        if (facetLink) {
                            const facetField = facetLink.dataset.facetField;
                            const facetValue = facetLink.dataset.facetValue;
                            await updateContentResultsWithFilter(searchForm, facetField, facetValue);
                        }
                    }, 500);
    
                    document.addEventListener('mouseover', handleMouseOver);
    
                    await updateFacetsAndResults(searchForm, searchTerm, searchSuggestion);
                } catch (err) {
                    console.error('loadSearchSuggest error : ', err);
                }
            }

            // Helper function to format product price
            function formatProductPrice(product) {
                const currency = window.theme.settings.money_with_currency_format.replace(/{{.*?}}/g, '');
                const currencyFormat = currency || '$';
                
                if (product.price_min && product.price_max) {
                    const minPrice = parseFloat(product.price_min);
                    const maxPrice = parseFloat(product.price_max);
                    
                    if (maxPrice > minPrice) {
                        return `${currencyFormat}${formatPrice(minPrice)} - ${currencyFormat}${formatPrice(maxPrice)}`;
                    } else {
                        return `${currencyFormat}${formatPrice(maxPrice)}`;
                    }
                } else if (product.price) {
                    return `${currencyFormat}${formatPrice(product.price)}`;
                }
                
                return '';
            }
        }
    });
});